"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var usePolicy = function () {
    var _a, _b;
    var t = (0, next_intl_1.useTranslations)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _c = (0, swr_hooks_1.useGamesByCategories)(), data = _c.data, isLoading = _c.isLoading;
    var games = (_b = (_a = data === null || data === void 0 ? void 0 : data['new']) === null || _a === void 0 ? void 0 : _a.previewGames) === null || _b === void 0 ? void 0 : _b.slice(0, 12);
    var isBreakpoints = Object.keys(breakpoints).length > 0;
    return {
        t: t,
        games: games,
        isBreakpoints: isBreakpoints,
        isTablet: breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.tablet,
        isSmallDesktop: breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.l,
        isDesktop: breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.xl,
        isLoading: isLoading,
    };
};
exports.default = usePolicy;
